module.exports = (__webpack_require__(1336))(3678);